export default __webpack_public_path__ + "static/media/image24.f4f92e6b.jpg";